import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuthStore } from '../../../stores/authStore';
import { useRegisterStore } from '../../../stores/registerStore';
import RegisterModal from '../components/register-modal';

/**
 * 独立注册页（/register）
 *
 * 复用 RegisterModal 六步注册流程，通过 wrapper 方式承载：
 * - isOpen 恒为 true（页面级，不走弹窗开合）
 * - onClose 跳回 /login，由 RegisterModal 内部 resetStore 清理表单状态
 * - 已登录用户访问时自动跳回首页；注册完成（第 5 步）除外——
 *   注册即登录会建立会话，若此处跳首页会导致完成页一闪而过，
 *   且 RegisterModal 被强行卸载跳过 handleClose，注册步骤状态残留
 */
export default function RegisterPage() {
  const navigate = useNavigate();
  const { user, loading } = useAuthStore();

  // 首次渲染前兜底重置注册流程状态（惰性初始化，早于首帧）：
  // 修复异常卸载（刷新/强跳）后 store 单例残留 currentStep=5
  // 导致再次进入直接显示完成页的问题
  useState(() => {
    useRegisterStore.getState().resetStore();
  });

  useEffect(() => {
    const { currentStep } = useRegisterStore.getState();
    if (!loading && user && currentStep !== 5) {
      navigate('/', { replace: true });
    }
  }, [user, loading, navigate]);

  return (
    <RegisterModal
      isOpen={true}
      onClose={() => navigate('/login', { replace: true })}
    />
  );
}
